import { Component } from '@angular/core';
import {customMatIcons} from '@app/app.icons';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {MediaMatcherService} from '@lib/services/media-matcher.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly mediaMatcherService: MediaMatcherService,
  ) {
    this.breakpointObserver
      .observe([Breakpoints.Small, Breakpoints.XSmall])
      .subscribe(event => {
        this.mediaMatcherService.isSmallScreen$.next(event.matches);
      });

    this.registerIcons();
  }

  private registerIcons(): void {
    customMatIcons.map(icon => {
      this.matIconRegistry.addSvgIcon(icon.name, this.domSanitizer.bypassSecurityTrustResourceUrl(icon.url));
    });
  }
}
